import getNative from './_getNative';
import root from './_root';

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

export default Promise;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_Promise.js
// module id = null
// module chunks = 